// @ts-nocheck
import React from 'react';

/**
 * PageHeader — eyebrow, serif title with optional italic emphasis via the
 * `<em>` inside `title`, sub line, and an actions slot on the right.
 */
const PageHeader = ({ eyebrow, title, sub, actions, className = '' }) => (
  <div className={`flex flex-wrap items-end justify-between gap-6 mb-6 ${className}`}>
    <div className="min-w-0">
      {eyebrow && (
        <div className="mov-mono inline-flex items-center gap-2 mb-2.5 text-mov-green-ink text-[11px] uppercase tracking-eyebrow">
          <span aria-hidden="true" className="mov-eyebrow-dot" />
          {eyebrow}
        </div>
      )}
      {title && (
        <h1 className="mov-display m-0 mb-1.5 text-[38px] leading-[1.05]">
          {title}
        </h1>
      )}
      {sub && (
        <p className="m-0 text-[14px] text-mov-ink-soft">{sub}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);

export const SectionHead = ({ title, sub, actions, className = '' }) => (
  <div className={`flex items-baseline justify-between gap-3 mt-9 mb-4 ${className}`}>
    <div>
      {title && (
        <h2 className="mov-display m-0 text-[26px] leading-[1.1] tracking-[-0.01em]">
          {title}
        </h2>
      )}
    </div>
    <div className="flex items-center gap-3">
      {sub && (
        <span className="mov-mono text-[11px] text-mov-ink-mute uppercase tracking-[0.12em]">
          {sub}
        </span>
      )}
      {actions}
    </div>
  </div>
);

export default PageHeader;
